var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/grid-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.19 2H12.75V8V8.75V13.75H22V8.75V8V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 10.25V15.25V15.75V16.19C2 19.83 4.17 22 7.81 22H11.25V15.75V15.25V10.25H2Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.25 2V8.75H2V7.81C2 4.17 4.17 2 7.81 2H11.25Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22 15.25V16.19C22 19.83 19.83 22 16.19 22H12.75V15.25H22Z",
    fill: "#6C84F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall);
export default __webpack_public_path__ + "static/media/wall.a90423f1b084bb4b4e02a768030b9e8c.svg";
export { ForwardRef as ReactComponent };